(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-guest-account-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('guest-account-menu')) {
    customElements.define('guest-account-menu', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.details = this.querySelector('details');
        this.trigger = this.querySelector('summary');
        this.panel = this.querySelector('nav');
        this.querySelector('.guest-account-menu__close').addEventListener('click', () => {
          this.details.open = false;
          this.trigger.focus();
        }, options);
        this.details.addEventListener('toggle', () => {
          this.trigger.setAttribute('aria-expanded', String(this.details.open));
          if (this.details.open) this.positionPanel();
        }, options);
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.details.open = false;
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.details.open) {
            event.preventDefault();
            event.stopPropagation();
            this.details.open = false;
            this.trigger.focus();
          }
        }, options);
        this.addEventListener('focusout', (event) => {
          // Safari can blur the trigger without focusing a tapped link. Keep the
          // panel visible until the click arrives; outside clicks close it above.
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.details.open = false;
        }, options);
        this.panel.addEventListener('click', (event) => {
          if (event.target.closest('a')) this.details.open = false;
        }, options);
        window.addEventListener('resize', () => this.positionPanel(), options);
        window.addEventListener('scroll', () => {
          if (this.details.open) this.positionPanel();
        }, options);
      }

      positionPanel() {
        if (!this.details.open) return;
        const rect = this.trigger.getBoundingClientRect();
        const width = this.panel.offsetWidth;
        const left = Math.max(10, Math.min(rect.right - width, document.documentElement.clientWidth - width - 10));
        const top = Math.max(10, rect.bottom + 8);
        this.panel.style.left = `${left}px`;
        this.panel.style.top = `${top}px`;
        this.panel.style.maxHeight = `${Math.max(0, window.innerHeight - top - 10)}px`;
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
